import { useMemo, useState, type FC } from "react"
import { Grid, Skeleton, Stack } from "@mui/material"

import Pagination from "widgets/common/Pagination"
import { paginateList } from "helpers/utils/common"
import type { TowerWithDevices } from "types/towers.types"
import CardWithTitle from "widgets/common/CardWithTitle"
import TowerCard from "./TowerCard"

interface TowerCardsSectionProps {
  towers: TowerWithDevices[]
  isLoading: boolean
}

const PAGE_LIMIT = 6

const TowerCardsSection: FC<TowerCardsSectionProps> = ({ towers, isLoading }) => {
  const [page, setPage] = useState(0)

  const pagedTowers = useMemo(
    () => paginateList(page, towers, PAGE_LIMIT),
    [page, towers],
  )

  if (isLoading) {
    return <Skeleton variant="rounded" height={"250px"} />
  }

  if (towers.length === 0) {
    return <></>
  }
  return (
    <Stack spacing={1} sx={{ width: "100%" }}>
      <CardWithTitle titleKey={"towers.MONITORED_TOWERS"}>
        <Stack gap={1}>
          <Grid container spacing={1} overflow="hidden">
            {pagedTowers.map((tower) => (
              <Grid item xs={12} sm={6} md={4} xl={4} key={tower.id}>
                <TowerCard tower={tower} />
              </Grid>
            ))}
          </Grid>
          {towers.length > PAGE_LIMIT && (
            <Pagination
              count={towers.length}
              page={page}
              setPage={setPage}
              limit={PAGE_LIMIT}
            />
          )}
        </Stack>
      </CardWithTitle>
    </Stack>
  )
}

export default TowerCardsSection
